<div class="headDivv">
  <h2 style="text-align:center;">Anc Settings</h2>
</div>
<app-clients-table></app-clients-table>
